import { useEffect } from "react";

import {
  doesAdobeScriptExist,
  injectAdobeScript,
} from "./useInjectAdobeAnalytics.helpers";

export const useInjectAdobeAnalytics = (adobeSource?: string) => {
  useEffect(() => {
    const scriptExists = doesAdobeScriptExist();
    if (adobeSource && !scriptExists) {
      injectAdobeScript(adobeSource);
    }
  }, [adobeSource]);
};
